/**
 * request.js
 * @authors Tommy (tao@winjoyit.com)
 * @date    2024-02-28 16:17:04
 * @version $Id$
 */
import axios from 'axios';
import { sign, nonce } from './sign';
import store from '@/store';
import router from '@/router'
import '@/plugins/element.js'



const baseURL = 'https://shop.joydesk.top/api/biz'
const appid = '2009171434'//2405272140'
let request = axios.create({
	baseURL,
	timeout: 6000,
	responseType: 'json',
	headers: {
		'Content-Type': 'application/json',
		'appid': appid,
		'X-API-Route': 'BIZ'
	}
})


// 请求拦截器
request.interceptors.request.use(
	config => {
		const sn = new Date().getTime();
		const noncestr = nonce();
		const token = store.state.token;

		config.headers.timestamp = sn;
		config.headers.noncestr = noncestr;
	
		config.headers.sign = sign(config.data, sn, noncestr);
		if (token) {
			config.headers.token = token;
			config.headers.SHOPID=store.state.userInfo.shop_id
		}
				
		return config;
	},
	error => {
		return Promise.reject(error);
	}
);

// 响应拦截器
request.interceptors.response.use(
	response => {
		const data = response.data;
		if (data.code === 99999) {
			store.commit('delToken');
			router.push('/login');
			return Promise.reject(new Error('token无效，请重新登录'));
		}
		return data;
	},
	error => {
		return Promise.reject(error);
	}
);
  


export default request